export const SUPPORT_POLICY_URL = 'https://www.mongodb.com/support-policy';
